function appendParams(path: string, params: { PurchaseOrder?: string }): string {
  if (params && params.PurchaseOrder) {
    const search = new URLSearchParams();
    if (params.PurchaseOrder) {
      search.append('PurchaseOrder', params.PurchaseOrder.toString());
    }
    path += `?${search.toString()}`;
  }

  return path;
}

export default [
  {
    id: '1',
    label: 'Purchase Order Enquiry in new tab',
    action: (params: { PurchaseOrder?: string }) => { window.open(appendParams('/purchase-order-enquiry/order-details', params)); }
  },
  {
    id: '2',
    label: 'Purchase Order Enquiry',
    action: (params: { PurchaseOrder?: string }) => { window.location.assign(appendParams('/purchase-order-enquiry/order-details', params)); }
  }
];
